module.exports = __webpack_public_path__ + "img/button.1e4e87a0.png";